import React from 'react';
import './style.scss';
import { Map } from 'immutable';
import classNames from 'classnames';

import {
  ImageFromField, CoreLink,
  Paragraph,
} from '@uncinc/react-drupal-core';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';
import {
  WysiwygField,
} from '..';

import {
  SCREEN_MOBILE,
  SCREEN_NORMAL,
  SCREEN_TABLET,
  SCREEN_WIDE,
  SCREEN_HUGE,
} from '../../config/constants';


const HeroBig = ({ entity, hideAlButtons = false, donationParagraph = null }) => {
  const hero = entity.getIn(['field_media_item', 0]);
  const heroType = entity.getIn(['field_media_item', 0, 'bundle']);
  const title = entity.getIn(['title', 0, 'value'], entity.getIn(['field_title', 0, 'value']));
  const body = entity.getIn(['body', 0, 'value'], entity.getIn(['field_body', 0, 'value'], null));
  const link = entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri']));
  const linkTitle = entity.getIn(['field_link', 0, 'title']);
  const fieldLink = entity.getIn(['field_link_to_page', 0, 'alias'], entity.getIn(['field_link_to_page', 0, 'uri']));
  const fieldLinkTitle = entity.getIn(['field_link_to_page', 0, 'title']);
  const secondaryLink = entity.getIn(['field_link_secondary', 0, 'alias'], entity.getIn(['field_link_secondary', 0, 'uri'], null));
  const secondaryLinkTitle = entity.getIn(['field_link_secondary', 0, 'title']);

  const heroTypeImage = 'image';
  const heroTypeVideo = 'video';

  const classes = classNames('HeroBig', {
    'with-donation': donationParagraph !== null,
  });

  return (
    <div className={classes}>
      <div className="HeroBig__media">
        <div className="HeroBig__media__image_mask" />
        <div className="HeroBig__media__wave_mask" />
        {hero.get('styles') && heroType === heroTypeImage && (
          <ImageFromField
            field={hero}
            imageStyles={Map({
              [SCREEN_MOBILE]: 'page_hero_image_mobile',
              [SCREEN_TABLET]: 'page_hero_image_tablet',
              [SCREEN_NORMAL]: 'page_hero_image_desktop',
              [SCREEN_WIDE]: 'page_hero_image_desktop',
              [SCREEN_HUGE]: 'page_hero_image_huge',
            })}
          />
        )}
        {hero.get('source') && heroType === heroTypeVideo && (
          <video
            src={hero.get('source')}
            autoPlay
            muted
            loop
            playsInline
          />
        )}
        <div className="HeroBig__media__spacers">
          <div className="HeroBig__media__spacers__spacer_gradient" />
          <div className="HeroBig__media__spacers__spacer_solid" />
        </div>
      </div>
      <div className="HeroBig__content">
        <Container>
          <div className="row">
            <div className="HeroBig__content__cta col-12 col-md-12 col-lg-6">
              <div className="HeroBig__content__cta__content">
                <h1 className="HeroBig__content__cta__content__title">{title}</h1>
                {body && (
                  <div className="HeroBig__content__cta__content__body">
                    <WysiwygField
                      property="schema:text"
                      html={body}
                    />
                  </div>
                )}

                {!hideAlButtons && (
                  <div className="HeroBig__content__cta__content__buttons">
                    {(link && donationParagraph === null) && (
                      <CoreLink href={link} className="HeroBig__link Button Button--cta">
                        {linkTitle}
                      </CoreLink>
                    )}
                    {fieldLink && (
                      <CoreLink href={fieldLink} className="HeroBig__link_secondary Button Button--default">
                        {fieldLinkTitle}
                        <div className="icon icon-arrow-right icon-variant-1" />
                      </CoreLink>
                    )}
                    {secondaryLink && (
                      <CoreLink href={secondaryLink} className="HeroBig__link_secondary Button Button--default">
                        {secondaryLinkTitle}
                        <div className="icon icon-arrow-right icon-variant-1" />
                      </CoreLink>
                    )}
                  </div>
                )}

                {donationParagraph !== null && (
                  <div className="HeroBig__donation">
                    <Paragraph
                      id={donationParagraph.get('target_id')}
                      entity={donationParagraph.get('entity')}
                      wide
                    />
                  </div>
                )}

              </div>
            </div>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default HeroBig;
